<template>
<div class="drawerWrap dangerDrawer">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
      <el-form-item label="隐患标题" prop="title">
        <el-input v-model="form.title" minlength="1" maxlength="50" placeholder="请输入隐患标题"></el-input>
      </el-form-item>
      <el-form-item label="隐患位置" prop="location">
        <el-input type="textarea" v-model="form.location" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="隐患描述" prop="info">
        <el-input type="textarea" v-model="form.info" :autosize="{ minRows: 2, maxRows: 8}" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="隐患风险等级" prop="riskLevel">
        <el-radio-group v-model="form.riskLevel">
          <el-radio :label="0">低风险</el-radio>
          <el-radio :label="1">中风险</el-radio>
          <el-radio :label="2">高风险</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="unitImg">
        <el-form-item label="隐患现场图片">
          <el-upload :class="{'demo-httpRequestImg':httpRequestImg}" :before-upload="beforeAvatarUpload" action :limit="1" list-type="picture-card" :http-request="handleHttpRequest" :on-preview="handlePictureCardPreview" :file-list="fileList" :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :append-to-body='true' :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </div>   
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      httpRequestImg: false, //展示单个图片
      form: {
        title: '',
        location: '', 
        info: '', 
        riskLevel: 0,
        dangerOriginal: ''
      },
      formRules: {
        title: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === "" || value === null || value == undefined) {
              callback(new Error("隐患标题不能为空"));
            } else if (value.length < 1) {
              callback(new Error("隐患标题大于1个字符"));
            } else if (value.length > 50) {
              callback(new Error("隐患标题小于50个字符"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }],
        location: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === "" || value === null) {
              callback(new Error("隐患位置不能为空"));
            } else if (value.length > 500) {
              callback(new Error("隐患位置长度不能超过500个字符"));
            } else if (value.length < 1) {
              callback(new Error("隐患位置长度不能少于1个字符"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    }
  },
  created() {
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },
    cancelHandle() { 
      // 取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      let formDates = {
        title: this.form.title,
        location: this.form.location, 
        info: this.form.info, 
        riskLevel: this.form.riskLevel
      };
      const formData = new FormData();
      if (this.form.dangerOriginal) {
        formData.append("dangerOriginal", this.form.dangerOriginal)
      }
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.$emit("update:loading", true);
        this.request.postParamsForm("/front/danger/add", formDates, formData).then(rs => {           
          this.$emit("update:loading", false);
          if (rs.code === 200) {
            this.msg.success('隐患上报成功')
            this.$emit('confirm', rs.code)
          } else if (rs.code == 500) {
            this.msg.warn(rs.msg);
          }
        });
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleHttpRequest(obj) {
      this.form.dangerOriginal = obj.file;
      this.httpRequestImg = true;
      this.msg.success('新增隐患现场图片上传成功')
    },
    //对上传图片的大小、格式进行限制
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持jpeg或jpg或png格式图片");
      }
      if (!isLt5M) {
        this.$message.warning("请上传1MB以内的图片!");
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M;
    },
    handleRemove(file, fileList) {
      this.httpRequestImg = false;
      this.dialogImageUrl = "";
      this.fileList = [];
    }    
  }
};
</script>
<style lang="scss">
.dangerDrawer {
  .drawerBody{
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;
    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width:100%;

      .el-textarea__inner {
        height: 80px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
        font-weight:400;
      }
    }

    .el-input {
      width: 100%;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

  .unitImg {
    .el-form-item {
      width: 100%;
    }
  }
  }
}
</style>
